import styled from 'styled-components';
import { Text14Light, Text15Light, Text15Regular } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 76rem;
  padding: 2.4rem 0;
  height: 100%;

  @media only screen and (max-width: 760px) {
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
`;

export const HeaderText = styled(Text14Light)`
  opacity: 0.4;
`;

export const Text = styled(Text15Regular)`
  line-height: 27px;
  letter-spacing: -0.42px;
`;

export const RequiredText = styled(Text15Light)`
  margin: 1.5rem 0;
  span {
    font-weight: 400;
    margin-left: 0.6rem;
  }
`;

export const OptionalText = styled(Text15Light)`
  opacity: 0.67;
  margin-bottom: 2rem;
  span {
    margin-left: 0.6rem;
  }
`;

export const SectionText = styled(Text15Light)`
  margin-bottom: 0.6rem;
`;

export const StyledButton = styled(Button)`
  width: 16rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const VoiceNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const VoiceNameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4.6rem;
  border-radius: 12px;
  border: 1px solid #d2d6db;
  padding: 0.8rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    cursor: pointer;
  }
`;

export const VoiceUploadContainer = styled.div`
  display: flex;
  gap: 1.4rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

export const TestVoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 2.4rem;
`;
export const Row = styled.div`
  display: flex;
  gap: 0.8rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
    gap: 0;
    margin-bottom: 2rem;
  }
`;

export const TestButton = styled(Button)`
  min-width: 12rem;
  width: 12rem;
  margin-top: 2.4rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
    min-width: unset;
    margin-top: unset;
  }
`;

export const ContinueButton = styled(Button)`
  margin-top: 3rem;
  width: 24rem;
  margin-inline: auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.2rem;
  flex-wrap: wrap;
`;

export const VoiceButton = styled.button`
  padding: 0.8rem 1.4rem;
  border-radius: 12px;
  border: ${props => (props.$selected ? '1px solid #61ade9' : '1px solid transparent')};
  outline: none;
  background: ${props => (props.$selected ? 'linear-gradient(180deg,  #1a88df 0%,  #1672ba 100%)' : '#f5f5f5')};
  color: ${props => (props.$selected ? '#fff' : '#1672ba')};
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: 400;
`;

export const RecordButton = styled(Button)`
  border-radius: 12px;
  background: #d8eaf9;
  margin-top: 1.2rem;
  border: none;
  color: #1672ba;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.42px;
`;

export const TipCard = styled.div`
  border-radius: 12px;
  background: #eef5fd;
  padding: 1.2rem 1.6rem 1.2rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 24.3rem;
`;

export const CardText = styled(Text14Light)`
  line-height: 23px;
  letter-spacing: -0.42px;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.7rem;
  overflow-x: auto;
  margin-top: 1.5rem;
`;

export const ChooseTabText = styled(Text15Regular)`
  letter-spacing: -0.42px;
  margin-top: 4.4rem;
  margin-bottom: 1.6rem;
`;

export const TabCardsContainer = styled.div`
  display: flex;
  gap: 1.6rem;

  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

export const TabCard = styled.div`
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  padding: 1.2rem 1.6rem 1.2rem 1.2rem;
  flex: 1;
  height: 12rem;
  gap: 0.9rem;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const StyledButton1 = styled(Button)`
  height: 3.4rem;
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, var(--Blue-500, #3e9be4) 6.75%, var(--Blue-700, #1672ba) 93.25%);
  font-size: 1.4rem;
`;

export const Row1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

export const TabCardText = styled(Text14Light)`
  letter-spacing: -0.408px;
`;
